/**
 * Products Table Component
 *
 * Component for displaying product sales data in a table
 */

import React, {useState} from 'react';
import {ProductSale} from '../models/report.model';
import AppTable from '../../../Presentation/components/ui/AppTable';
import {AppText} from '../../../Presentation/components/ui/Typography';
import {TableColumn} from '../../../Presentation/components/ui/AppTable';
import {formatCurrency} from '../../../Presentation/utils/numberUtils';

interface ProductsTableProps {
  products: ProductSale[];
}

export const ProductsTable: React.FC<ProductsTableProps> = ({products}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Calculate pagination
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = products.slice(startIndex, endIndex);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setCurrentPage(1); // Reset to first page when page size changes
  };

  const columns: TableColumn<ProductSale>[] = [
    {
      key: 'product_name',
      title: 'اسم المنتج',
      render: (product) => <AppText>{product.product_name}</AppText>
    },
    {
      key: 'quantity_sold',
      title: 'الكمية المباعة',
      render: (product) => <AppText>{product.quantity_sold}</AppText>
    },
    {
      key: 'unit_price',
      title: 'سعر الوحدة',
      render: (product) => <AppText>{formatCurrency(product.unit_price)}</AppText>
    },
    {
      key: 'total_revenue',
      title: 'إجمالي الإيرادات',
      render: (product) => <AppText>{formatCurrency(product.total_revenue)}</AppText>
    }
  ];

  return (
    <AppTable
      columns={columns}
      data={paginatedData}
      rowKey={(product) => product.product_id}
      emptyText="لا توجد منتجات متاحة"
      hidePagination={false}
      page={currentPage}
      pageSize={pageSize}
      totalCount={products.length}
      onPageChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}
    />
  );
};
